import '@campact/camper/core/CmprAlertBanner';
import '@campact/camper/core/CmprFooterNavigation';
import '@campact/camper/core/CmprLogo38Degrees';
import '@campact/camper/core/CmprLogoAufstehn';
import '@campact/camper/core/CmprLogoCampact';
import '@campact/camper/core/CmprLogoDeclic';
import '@campact/camper/core/CmprLogoSkiftet';
import '@campact/camper/core/CmprLogoWeact';
import '@campact/camper/core/CmprSiteHeader';
import '@campact/camper/icons/CmprIconSolidArrowRightFromBracket';

import '@cta/shared/appsignal';
import cookieCheck from './javascripts/cookie_check';
import piwikConsentForm from './javascripts/piwik_consent_form';
import { initPiwikWebAnalytics } from './javascripts/piwik_web_analytics';

window.addEventListener('DOMContentLoaded', () => {
  cookieCheck();

  initPiwikWebAnalytics();
  piwikConsentForm(); // TODO: Move into PiwikWebAnalytics
});
